export default "__VITE_ASSET__CjQ2imX2__"